import React from 'react';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import useMenuQrHooks from './menuQr-hooks';
import CustomDialog from '../../../../../Components/Dialog/customDialog';
import QrDialog from '../Dialogs/QRMenu/qrDialog';
import QrCodeCard from './QrCodeCard';
import styles from './qr.module.scss';
import { IDineInConfig } from '../../../../../Interfaces/responseTypes';

export interface IQrProps {
  qrImage: string;
  company_id: number;
  companyTitle: string;
  dineIn?: IDineInConfig | null;
}

const Qr: React.FC<IQrProps> = (props) => {
  const {
    isLoading,
    isDialogOpen,
    fullImageUrl,
    menuLink,
    selectedSize,
    PRESET_SIZES,
    isDineInActive,
    dineInSections,
    cardLabels,
    downloadImageUrl,
    onCloseDialog,
    handleDownload,
    onSetImageSizes,
    openDownloadDialog,
    copyLink,
    copyAndShareTelegram,
    shareOnWhatsApp,
    shareOnFacebook,
  } = useMenuQrHooks(props);
  const { t } = useGeneralHooks();

  const hasDineInQrSections = isDineInActive && dineInSections.length > 0;

  return (
    <>
      <div className={styles.container}>
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <p>{t('My_Business.Qr.Header')}</p>
          </div>
          <div className={styles.mainCardWrap}>
            <QrCodeCard
              imageUrl={fullImageUrl}
              title={t('My_Business.Qr.Main_Title')}
              link={menuLink}
              downloadLabel={cardLabels.downloadLabel}
              shareLabel={cardLabels.shareLabel}
              linkLabel={cardLabels.linkLabel}
              copyLinkLabel={cardLabels.copyLinkLabel}
              onDownload={() => openDownloadDialog(fullImageUrl, 'menu-qr-code.png')}
              onCopyLink={() => copyLink(menuLink)}
              onShareTelegram={() => copyAndShareTelegram(menuLink)}
              onShareWhatsApp={() => shareOnWhatsApp(menuLink)}
              onShareFacebook={() => shareOnFacebook(menuLink)}
            />
          </div>
        </section>

        {isDineInActive && (
          <section className={styles.section}>
            <div className={styles.sectionHeader}>
              <p>{t('My_Business.Qr.Dine_In_Section_Title')}</p>
              <span className={styles.sectionHint}>
                {hasDineInQrSections
                  ? t('My_Business.Qr.Dine_In_Section_Hint')
                  : t('My_Business.Qr.Dine_In_No_QR')}
              </span>
            </div>

            {hasDineInQrSections && (
              <div className={styles.dineInSections}>
                {dineInSections.map((section) => (
                  <div key={section.unit.type} className={styles.dineInTypeSection}>
                    <div className={styles.typeHeader}>
                      <h3>{section.typeLabel}</h3>
                      <span>{t('My_Business.Qr.Unit_Count', { count: section.items.length })}</span>
                    </div>
                    <div className={styles.dineInGrid}>
                      {section.items.map((item) => (
                        <QrCodeCard
                          key={`${section.unit.type}-${item.number}`}
                          imageUrl={item.imageUrl}
                          title={item.title}
                          badge={item.badge}
                          link={item.link}
                          downloadLabel={cardLabels.downloadLabel}
                          shareLabel={cardLabels.shareLabel}
                          linkLabel={cardLabels.linkLabel}
                          copyLinkLabel={cardLabels.copyLinkLabel}
                          onDownload={() => openDownloadDialog(item.imageUrl, item.fileName)}
                          onCopyLink={() => copyLink(item.link)}
                          onShareTelegram={() => copyAndShareTelegram(item.link)}
                          onShareWhatsApp={() => shareOnWhatsApp(item.link)}
                          onShareFacebook={() => shareOnFacebook(item.link)}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        )}
      </div>

      <CustomDialog
        open={isDialogOpen}
        onClose={onCloseDialog}
        children={
          <QrDialog
            image={downloadImageUrl || fullImageUrl}
            onDownLoad={handleDownload}
            onClose={onCloseDialog}
            presetData={PRESET_SIZES}
            selectedSize={selectedSize}
            onSetImgSize={onSetImageSizes}
            loading={isLoading}
          />
        }
      />
    </>
  );
};

export default Qr;
